module.exports = __webpack_public_path__ + "img/dbf.0a66809b.png";